import React, { useEffect, useState } from 'react';
import '../../../components/FileCode/FileCode.scss';
import RoutingStepsData from './RoutingStepsData.json';
import TableRoutingSteps from './TableRoutingSteps';
import { createRoutingStep, updateOneRoutingStep, deleteRoutingStep, searchRoutingSteps, getSearchContextId } from './RoutingStepsServices';
import styles from './RoutingSteps.module.scss';
import '../../../GlobalStyle.scss';

import crossIcon from '../../../fsa-style/img/crossIcon.svg';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import SuccessProcessGrowl from '../../../components/SuspenseQueue/SuccessProcessGrowl';
import AsyncSelect from 'react-select/async';
import { searchBUOWByText, searchWorkgroups } from '../../../services/inBasketService';
import ErrorGrowl from '../../../components/SuspenseQueue/ErrorGrowl';

import Breadcrumb from '../../../newcomponents/Breadcrumb/Breadcrumb';
import Footer from '../../../newcomponents/Footer/Footer';
import { DeleteModal } from '../../../newcomponents/DeletePopup/DeleteModal';
import { GlobalLoader } from '../../../newcomponents/GlobalLoader/GlobalLoader.js';
import CustomButton from '../../../newcomponents/CustomButton/CustomButton';
import SearchAdminPanelComponent from '../../../newcomponents/SearchAdminPanelComponent/SearchAdminPanelComponent';
import { handleIsRequiredError, handleMaxLimitError } from '../../../utils/helper/handleReuiredErrorFunc';

var _ = require('lodash');

const breadcrumbData = [
  { title: 'Administrator Panel', link: '/admin' },
  { title: 'Routing Steps', link: '' },
];

export default function RoutingSteps() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  // const [selectedRows, setSelectedRows] = useState();
  const [createEditModalShow, setCreateEditModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [selectedDeleteRowData, setSelectedDeleteRowData] = useState();
  const [isNewRecord, setIsNewRecord] = useState(false);
  const [message, setMessage] = useState();
  const [isSuccessGrowlHidden, setIsSuccessGrowlHidden] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [isErrorGrowlHidden, setIsErrorGrowlHidden] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [sorting, setSorting] = useState({ column: '', order: '' });
  const [routingStepsDetails, setRoutingStepsData] = useState(RoutingStepsData);

  const [formData, setFormData] = useState({
    contextId: '',
    dttm: '',
    routeOrigin: '',
    step: '',
    subStep: '',
    stepName: '',
    adHoc: true,
    adHocRouter: '',
    parSeq: '',
    status: '',
    disposition: '',
    targetUserOrWorkgroup: '',
    buowId: '',
    userOrWorkgroupId: '',
    id: '',
  });

  async function fetchRoutingStepsData() {
    let payload = {
      text: searchText,
      column: sorting.column,
      order: sorting.order,
    };

    await searchRoutingSteps(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  }

  useEffect(() => {
    setLoading(true);
    fetchRoutingStepsData();
  }, []);

  const onRemoveSort = async () => {
    setLoading(true);
    // await fetchRoutingStepsData();
    let payload = {
      text: searchText,
      column: '',
      order: '',
    };
    setSorting({ column: '', order: '' });

    await searchRoutingSteps(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const onPageChange = ({ page }) => {
    setPageSize(page.take);
    setPage(page.skip / page.take);
  };

  const createNewFunc = () => {
    setFormData({
      contextId: '',
      dttm: null,
      routeOrigin: '',
      step: '',
      subStep: '',
      stepName: '',
      adHoc: true,
      adHocRouter: '',
      parSeq: '',
      status: '',
      disposition: '',
      targetUserOrWorkgroup: '',
      buowId: '',
      userOrWorkgroupId: '',
      id: '',
    });
    setIsNewRecord(true);
    setCreateEditModalShow(true);
  };

  const EditRowDataFunc = (data) => {
    setFormData({
      contextId: data.contextId,
      dttm: data.dttm,
      routeOrigin: data.routeOrigin,
      step: data.step,
      subStep: data.subStep,
      stepName: data.stepName,
      adHoc: data.adHoc,
      adHocRouter: data.adHocRouter,
      parSeq: data.parSeq,
      status: data.status,
      disposition: data.disposition,
      targetUserOrWorkgroup: data.targetUserOrWorkgroup,
      buowId: data.buowId,
      userOrWorkgroupId: { label: data.workGroup.workgroupDisplayName, value: data.userOrWorkgroupId },
      id: data.id,
    });
    setIsNewRecord(false);
    setCreateEditModalShow(true);
  };

  const DeleteRowDataFunc = (DeleteRowData) => {
    setDeleteModalShow(true);
    setSelectedDeleteRowData(DeleteRowData);
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchText(value.trimStart());
    if (value.length > 2) onSearch(value);
    if (value.length === 0) onSearch(value);
  };

  const onSearch = async (searchText) => {
    setLoading(true);
    let payload = {
      text: searchText,
      column: sorting.column,
      order: sorting.order,
    };

    await searchRoutingSteps(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const DeleteDataFunc = (DeleteData) => {
    setLoading(true);
    const sendData = {
      id: DeleteData.id,
    };
    deleteRoutingStep(sendData).then(async (response) => {
      if (response) {
        setDeleteModalShow(false);
        await fetchRoutingStepsData();
        setLoading(false);
        setIsSuccessGrowlHidden(false);
        setMessage('Record deleted successfully');
        setTimeout(() => {
          setIsSuccessGrowlHidden(true);
        }, 3000);
      } else if (response.error) {
        setIsErrorGrowlHidden(false);
        setMessage(response.error.message ? response.error.message : 'Something went wrong');

        setTimeout(() => {
          setIsErrorGrowlHidden(true);
        }, 3000);
        setLoading(false);
      }
    });
  };

  const clearSearch = async () => {
    setLoading(true);
    setSearchText('');
    setSorting({ column: '', order: '' });
    setPage(0);
    setLoading(false);
    // Clear sort from table header
    let newRoutingStepsData = JSON.parse(JSON.stringify(routingStepsDetails));
    newRoutingStepsData.forEach((itm) => {
      itm.sortType = '';
    });
    setRoutingStepsData(newRoutingStepsData);
    await fetchNewRoutingStepsData();
  };

  // Code needs to change
  const fetchNewRoutingStepsData = async () => {
    let payload = {
      text: '',
      column: '',
      order: '',
    };
    await searchRoutingSteps(payload).then((response) => {
      setData(response.data);
      setPage(0);
      setLoading(false);
    });
  };

  const onSortData = async (selectedColumn) => {
    setLoading(true);
    let sortObj = {
      column: selectedColumn.field,
      order: selectedColumn.sortType,
    };
    setSorting(sortObj);
    let payload = {
      column: selectedColumn.field,
      order: selectedColumn.sortType,
      text: searchText,
    };
    await searchRoutingSteps(payload).then((response) => {
      setData(response.data);
      setLoading(false);
    });
  };

  return (
    <div className={styles.routingStepsPage}>
      {isLoading && <GlobalLoader />}

      <Breadcrumb data={breadcrumbData} />
      <div className={styles.routingStepsContent}>
        <h1 className={styles.pageTitle}>Routing Steps</h1>
        <div>
          <div className={styles.searchSection}>
            <div className={styles.keywordSearchTitle}>Keyword Search</div>
            <div className={styles.searchOuterContainer}>
              <div className="d-flex">
                <SearchAdminPanelComponent searchText={searchText} handleSearch={handleSearch} onSearch={onSearch} clearSearch={clearSearch}></SearchAdminPanelComponent>
              </div>
              <div>
                <CustomButton title="Create Record" className={styles.createRecordBtnStyle} onClick={createNewFunc} />
              </div>
            </div>
          </div>
        </div>

        <div className={[styles.routingStepsTable, 'glbRoutingStepsTable'].join(' ')}>
          <TableRoutingSteps
            data={data}
            EditRowDataFunc={EditRowDataFunc}
            DeleteRowDataFunc={DeleteRowDataFunc}
            setDeleteModalShow={setDeleteModalShow}
            fields={routingStepsDetails}
            page={page} // Pass the page state from the parent component
            pageSize={pageSize} // Pass the pageSize state from the parent component
            onPageChange={onPageChange}
            onSortData={onSortData}
            onRemoveSort={onRemoveSort}
          />
        </div>

        <CreateEditRoutingStepsModal
          show={createEditModalShow}
          isNewRecord={isNewRecord}
          formData={formData}
          setFormData={setFormData}
          fetchRoutingStepsData={fetchRoutingStepsData}
          setCreateEditModalShow={setCreateEditModalShow}
          onHide={() => setCreateEditModalShow(false)}
          setIsSuccessGrowlHidden={setIsSuccessGrowlHidden}
          setMessage={setMessage}
          setIsErrorGrowlHidden={setIsErrorGrowlHidden}
          isLoading={setLoading}
        />
        {deleteModalShow && (
          <DeleteModal
            show={deleteModalShow}
            DeleteDataFunc={DeleteDataFunc}
            onHide={() => setDeleteModalShow(false)}
            setDeleteModalShow={setDeleteModalShow}
            selectedDeleteRowData={selectedDeleteRowData}
            setIsSuccessGrowlHidden={setIsSuccessGrowlHidden}
            setMessage={setMessage}
            popupTitle={'Routing Step'}
          ></DeleteModal>
        )}

        <SuccessProcessGrowl isSuccessGrowlHidden={isSuccessGrowlHidden} setIsSuccessGrowlHidden={setIsSuccessGrowlHidden} message={message} />
        <ErrorGrowl isErrorGrowlHidden={isErrorGrowlHidden} setIsErrorGrowlHidden={setIsErrorGrowlHidden} message={message} />
      </div>

      {/* <Footer /> */}
    </div>
  );
}

const CreateEditRoutingStepsModal = (props) => {
  // const [UTCDate, setUTCDate] = useState(moment(props.formData.dttm).format('M/DD/YY, h:mm:ss A'));
  const [isRequiredError, setisRequiredError] = useState(false);
  // const [searchData, setSearchData] = useState([]);
  // const [searchDataBUOW, setSearchDataBUOW] = useState([]);

  // const [selectedUser, setSelectedUser] = useState([]);

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 32,
      minHeight: 32,
      width: '100%',
    }),
    menu: (base) => ({
      ...base,
      width: '100%',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: 32,
      // position: 'initial',
      padding: '0px 8px',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: 32,
    }),
    input: (provided, state) => ({
      ...provided,
      height: 32,
      padding: 0,
      margin: 0,
    }),
    container: (provided, state) => ({
      ...provided,
      minWidth: '100%',
    }),
  };

  useEffect(() => {
    // if (props.formData.dttm !== null) setUTCDate(moment(props.formData.dttm).format('YYYY-MM-DDTHH:MM'));
    // else setUTCDate(null);
    setisRequiredError(false);
  }, [props.formData]);

  const onChangeContextId = (event) => {
    if (event == null)
      return props.setFormData((prevData) => ({
        ...prevData,
        contextId: '',
      }));

    const { value } = event;
    const updatedValue = value === '' ? null : value;
    props.setFormData((prevData) => ({
      ...prevData,
      contextId: updatedValue,
    }));
  };

  const loadOptions = async (inputValue, callback) => {
    if (inputValue === '') {
      // setSearchData([]);
    } else {
      await searchWorkgroups(inputValue).then(async (response1) => {
        let options = await response1.data.map((res) => {
          return { label: res.workgroupDisplayName, value: res.workgroupId };
        });

        // setSearchData(options);
        callback(options);
      });
    }
  };

  const loadBUOWOptions = async (inputValue, callback) => {
    if (inputValue === '') {
      // setSearchDataBUOW([]);
    } else {
      await searchBUOWByText(inputValue).then(async (response1) => {
        let options = await response1.data.map((res) => {
          return { label: res.buowId, value: res.buowId };
        });
        // setSearchDataBUOW(options);
        callback(options);
      });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedValue = value === '' ? null : value;
    props.setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue === null || undefined ? updatedValue : updatedValue.trimStart(),
    }));
  };
  const handleDispositionChange = (event) => {
    if (event.target.value == null)
      return props.setFormData((prevData) => ({
        ...prevData,
        disposition: '',
      }));
    props.setFormData((prevData) => ({
      ...prevData,
      disposition: event.target.value,
    }));
  };
  const handleDropdownChange = (event) => {
    if (event == null)
      return props.setFormData((prevData) => ({
        ...prevData,
        userOrWorkgroupId: '',
      }));
    props.setFormData((prevData) => ({
      ...prevData,
      userOrWorkgroupId: event,
    }));
  };

  const handleDropdownChangeBUOW = (event) => {
    if (event == null)
      return props.setFormData((prevData) => ({
        ...prevData,
        buowId: '',
      }));
    const { value } = event;
    const updatedValue = value === '' ? null : value;
    props.setFormData((prevData) => ({
      ...prevData,
      buowId: updatedValue,
    }));
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    const booleanValue = value === 'true';
    props.setFormData((prevData) => ({
      ...prevData,
      adHoc: booleanValue,
    }));
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    props.setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const loadContextIdList = async (inputValue, callback) => {
    if (inputValue === '') {
      // setSearchDataBUOW([]);
    } else {
      await getSearchContextId(inputValue).then(async (response1) => {
        let options = await response1.data.map((res) => {
          return { label: res.contextId, value: res.contextId };
        });
        // setSearchDataBUOW(options);
        callback(options);
      });
    }
  };

  const AddSubmitFunct = async (data) => {
    try {
      if (
        !props.formData.contextId ||
        !props.formData.routeOrigin ||
        !props.formData.step ||
        !props.formData.subStep ||
        !props.formData.stepName ||
        !props.formData.buowId ||
        !props.formData.userOrWorkgroupId ||
        data.contextId.length > 50
      ) {
        setisRequiredError(true);
        return;
      }
      let payload = _.cloneDeep(data);

      payload.userOrWorkgroupId = payload.userOrWorkgroupId.value;
      delete payload.dttm;
      props.isLoading(true);

      await createRoutingStep(payload)
        .then((response) => {
          if (response.data) {
            props.fetchRoutingStepsData();
            props.setCreateEditModalShow(false);
            props.setIsSuccessGrowlHidden(false);
            props.setMessage('Record created successfully');

            setTimeout(() => {
              props.setIsSuccessGrowlHidden(true);
            }, 3000);
            props.isLoading(false);
          } else if (response.error) {
            props.setIsErrorGrowlHidden(false);
            props.setMessage(response.error.message ? response.error.message : 'Something went wrong');

            setTimeout(() => {
              props.setIsErrorGrowlHidden(true);
            }, 3000);
            props.isLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const EditSubmitFunct = async (data) => {
    if (
      !props.formData.contextId ||
      !props.formData.routeOrigin ||
      props.formData.subStep === null ||
      !props.formData.stepName ||
      !props.formData.buowId ||
      !props.formData.userOrWorkgroupId ||
      props.formData.step === '' ||
      data.contextId.length > 50
    ) {
      setisRequiredError(true);
      return;
    }
    let payload = _.cloneDeep(data);
    payload.userOrWorkgroupId = payload.userOrWorkgroupId.value;
    props.isLoading(true);
    await updateOneRoutingStep(payload).then((response) => {
      if (response.data) {
        props.setIsSuccessGrowlHidden(false);
        props.setMessage('Record updated successfully');

        setTimeout(() => {
          props.setIsSuccessGrowlHidden(true);
        }, 3000);

        props.fetchRoutingStepsData();
        props.setCreateEditModalShow(false);
        props.isLoading(false);
      } else if (response.error) {
        props.setIsErrorGrowlHidden(false);
        props.setMessage(response.error.message ? response.error.message : 'Something went wrong');

        setTimeout(() => {
          props.setIsErrorGrowlHidden(true);
        }, 3000);
        props.isLoading(false);
      }
    });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={[styles.routingStepsModal, 'glbRoutingStepsModalStyle'].join(' ')}
      onHide={props.onHide}
    >
      <div>
        <Modal.Header>
          <div className={styles.modalHeader}>
            <div>
              <h2 className={styles.modalHeaderTitle}>{props.isNewRecord ? 'Create Record' : 'Edit Record'}</h2>
            </div>
            <div
              className={styles.modalHeaderIcon}
              onClick={() => {
                props.setCreateEditModalShow(false);
              }}
            >
              <img src={crossIcon} alt="cross icon" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className={styles.routingStepsModalBody}>
          <div className={[styles.modalBodySection, 'row mr-0 ml-0'].join(' ')}>
            {props.isNewRecord === false && (
              <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
                <label>DTTM *</label>
                {/* <input type="datetime-local" name="dttm" value={UTCDate} disabled={true} /> */}
                <input name="routeOrigin" value={moment(props.formData.dttm).format('M/DD/YY, h:mm:ss A')} disabled={true} />
              </div>
            )}

            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Context Id *</label>
              <AsyncSelect
                styles={customStyles}
                isClearable
                isDisabled={!props.isNewRecord}
                loadOptions={loadContextIdList}
                value={props?.formData?.contextId !== '' ? { label: props?.formData?.contextId, value: props?.formData?.contextId } : null}
                onChange={onChangeContextId}
              />
              {(props.formData.contextId === null || props.formData.contextId === '') && isRequiredError === true && handleIsRequiredError()}
              {props.formData.contextId.length > 50 && isRequiredError === true && handleMaxLimitError(50)}
            </div>

            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Route Origin *</label>
              <input name="routeOrigin" value={props.formData.routeOrigin} onChange={handleInputChange} disabled={props.isNewRecord ? false : true} />
              {(props.formData.routeOrigin === null || props.formData.routeOrigin === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Step *</label>
              <input name="step" value={props.formData.step} onChange={handleInputChange} disabled={props.isNewRecord ? false : true} type="number" />
              {(props.formData.step === null || props.formData.step === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Sub Step *</label>
              <input name="subStep" value={props.formData.subStep} onChange={handleInputChange} disabled={props.isNewRecord ? false : true} type="number" />
              {(props.formData.subStep === null || props.formData.subStep === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Step Name *</label>
              <input name="stepName" value={props.formData.stepName} onChange={handleInputChange} />
              {(props.formData.stepName === null || props.formData.stepName === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')} style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <div className={styles.radioBtnContainer}>
                  <label className="mr-2">Ad Hoc: </label>
                  <input
                    style={{ display: 'inline-grid', width: '20px', height: '20px', borderRadius: '10px' }}
                    type="radio"
                    name="adHoc"
                    value={true}
                    checked={props.formData.adHoc === true}
                    onChange={handleRadioChange}
                  />
                  <label className="m-2">True</label>
                  <input
                    style={{ display: 'inline-grid', width: '20px', height: '20px', borderRadius: '10px' }}
                    type="radio"
                    name="adHoc"
                    value={false}
                    checked={props.formData.adHoc === false}
                    onChange={handleRadioChange}
                  />
                  <label className="m-2 ">False</label>
                </div>
              </div>
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Ad Hoc Router</label>
              <input name="adHocRouter" value={props.formData.adHocRouter} onChange={handleInputChange} />
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Parallel or Sequence</label>
              <select id="selectField" name="parSeq" value={props.formData.parSeq} onChange={handleSelectChange}>
                <option value={''} disabled>
                  --Select--
                </option>
                <option value="Parallel">Parallel</option>
                <option value="Sequential">Sequential</option>
              </select>
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Status</label>
              <select id="selectField" name="status" value={props.formData.status} onChange={handleSelectChange}>
                <option value={''} disabled>
                  --Select--
                </option>
                <option value="Complete">Complete</option>
                <option value="Future">Future</option>
                <option value="Waiting">Waiting</option>
              </select>
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Disposition</label>
              <select name="disposition" value={props.formData.disposition} onChange={handleDispositionChange}>
                <option value={''} disabled>
                  --Select--
                </option>
                <option value="Routed">Routed</option>
                <option value="Routed/Approved">Routed/Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Redirected">Redirected</option>
              </select>
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Target User or Workgroup</label>
              <select id="selectField" name="targetUserOrWorkgroup" value={props.formData.targetUserOrWorkgroup} onChange={handleSelectChange}>
                <option value={''} disabled>
                  --Select--
                </option>
                <option value="W">W</option>
                <option value="U">U</option>
              </select>
            </div>
            <div className={[styles.inputFieldSection, 'col-4'].join(' ')}>
              <label>Buow ID *</label>
              <AsyncSelect
                styles={customStyles}
                isClearable
                isDisabled={props.isNewRecord ? false : true}
                loadOptions={loadBUOWOptions}
                value={props?.formData?.buowId !== '' ? { label: props?.formData?.buowId, value: props?.formData?.buowId } : null}
                onChange={handleDropdownChangeBUOW}
              />

              {(props.formData.buowId === null || props.formData.buowId === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
            <div className={[styles.searchFieldDiv, 'col-4'].join(' ')}>
              <label className="mb-0">User or Workgroup *</label>
              <AsyncSelect styles={customStyles} isClearable loadOptions={loadOptions} value={props?.formData?.userOrWorkgroupId} onChange={handleDropdownChange} />
              {(props.formData.userOrWorkgroupId === null || props.formData.userOrWorkgroupId === '') && isRequiredError === true && handleIsRequiredError()}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.routingStepsFooter}>
          <div style={{ display: 'flex', gap: '3rem' }} className={'col-12 justify-content-center'}>
            <CustomButton title="Cancel" className={styles.cancelRecordBtn} onClick={() => props.setCreateEditModalShow(false)} />

            {props.isNewRecord ? (
              <CustomButton title="Save" className={styles.saveRecordBtn} onClick={() => AddSubmitFunct(props.formData)} />
            ) : (
              <CustomButton title="Update" className={styles.saveRecordBtn} onClick={() => EditSubmitFunct(props.formData)} />
            )}
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};
